package app.model

import kotlinx.serialization.Serializable

@Serializable
data class ProjectVariable(
    val id: Int,
    val projectId: Int,
    val name: String,
    val values: List<ProjectVariableValue>
) {
    init {
        // -> enforce default value present
        require(values.any { it.stageId == null && it.companyId == null }) { "No default Variable Value" }
    }

}

// companyId && stageId == null <-> default value
// companyId != null <-> company scope
// stageId != null <-> stage scope
// companyId && stageId != null <-> company-stage value
@Serializable
data class ProjectVariableValue(
    val companyId: Int?,
    val stageId: Int?,
    val value: String,
)
